<template>
  <datos
    :persona="persona"
  />
</template>

<script>
import datos from './components/datosFacturacion.vue'

export default {
  components: {
    datos,
  },
  data() {
    return {
      persona: null,
    }
  },
}
</script>
